<template lang="">
  <div class="justify-content-center">
    <ToastPrime />

    <div class="justify-content-center m-5">
      <img src="@/assets/logo.png" @click="home()" class="logo m-2" />
    </div>
    <div v-if="header == 'Sign In'" id="outer">
      <h1 class="text-center">{{ $t("loggingComponentHeader1") }}</h1>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <h4 class="field">{{ $t("email") }}</h4>
          <InputTextPrime class="field" v-model="email" style="width: 100%" type="email" />
          <h4 class="field">{{ $t("password") }}</h4>
          <InputTextPrime class="field" v-model="password" style="width: 100%" type="password" />
        </template>
        <template #footer>                                        <!--@click="setUser-->
          <ButtonPrime class="p-button-success p-2" style="width: 100%" @click="openModal" :label="header" />
        </template>
      </CardPrime>
      <div class="p-4"></div>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <p>                                                    
            {{ $t("loggingText1_1") }} <a class="text-blue-400" @click="createUser()">{{ $t("loggingText2_1") }}</a>
          </p>
          <p>
            {{ $t("loggingText3_1") }} <a class="text-blue-400" @click="changePassword()">{{ $t("loggingText3_2") }}</a>
          </p>  
        </template>
      </CardPrime>
    </div>
    <div v-if="header == 'Sign Up'" id="outer">
      <h1 class="text-center">{{ $t("loggingComponentHeader2") }}</h1>
      <CardPrime style="width: 50rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <div class="formgrid grid">
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("firstName") }}</h4>
              <InputTextPrime class="field" v-model="firstName" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("lastName") }}</h4>
              <InputTextPrime class="field" v-model="lastName" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("company") }}</h4>
              <InputTextPrime class="field" v-model="company" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("charge") }}</h4>
              <InputTextPrime class="field" v-model="charge" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("sector") }}</h4>
              <InputTextPrime class="field" v-model="sector" style="width: 100%" type="text" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("email") }}</h4>
              <InputTextPrime class="field" v-model="email" style="width: 100%" type="email" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("password") }}</h4>
              <InputTextPrime class="field" v-model="password" style="width: 100%" type="password" />
            </div>
            <div class="field col-12 md:col-6">
              <h4 class="field">{{ $t("password2") }}</h4>
              <InputTextPrime class="field" v-model="confirmPassword" style="width: 100%" type="password" />
            </div>
          </div>
        </template>
        <template #footer>
          <ButtonPrime class="p-button-success p-2" style="width: 100%" @click="setUser" :label="header" />
        </template>
      </CardPrime>
      <div class="p-4"></div>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <p>
            {{ $t("loggingText1_2") }}<a class="text-blue-400" @click="createUser()">{{ $t("loggingText2_2") }}</a>
          </p>
        </template>
      </CardPrime>
    </div>
   <div v-if="header == 'Change Password'" id="outer">
    <h1 class="text-center">{{ $t("loggingComponentHeader3") }}</h1>
    <CardPrime style="width: 50rem" class="text-left justify-content-center" id="inner">
      <template #content>
        <h4 class="field">{{ $t("email") }}</h4>
        <InputTextPrime class="field" v-model="email" style="width: 100%" type="email" />
        <h4 class="field">{{ $t("actualPassword") }}</h4>
        <InputTextPrime class="field" v-model="password" style="width: 100%" type="password" />
        <h4 class="field">{{ $t("newPassword") }}</h4>
        <InputTextPrime class="field" v-model="newPassword" style="width: 100%" type="password" />
        <h4 class="field">{{ $t("newPassword2") }}</h4>
        <InputTextPrime class="field" v-model="confirmNewPassword" style="width: 100%" type="password" />
        </template>
      <template #footer>
        <ButtonPrime class="p-button-success p-2" style="width: 100%" @click="setNewPassword" :label="header" />
      </template>
    </CardPrime><div class="p-4"></div>
      <CardPrime style="width: 25rem" class="text-left justify-content-center" id="inner">
        <template #content>
          <p>
            {{ $t("loggingText1_2") }}<a class="text-blue-400" @click="createUser()">{{ $t("loggingText2_2") }}</a>
          </p>
        </template>
      </CardPrime>
   </div> 
  </div>
  <div>
    
    <DialogPrime
      :header="$t('headerModalLogging')"
      v-model:visible="modalVisible"
      :breakpoints="{ '960px': '50vw', '640px': '50vw' }"
      :style="{ width: '40vw' }">

      <div class="button-container">

        <ButtonPrime class="button-login" style="width: 60%" @click="goToEcobuq">
          ECOBUQ
        </ButtonPrime>
        <ButtonPrime class="button-login" style="width: 60%"  @click="goToNeobuq">
          NEOBUQ
        </ButtonPrime>
      </div>

      <p style="padding-top: 3%"><strong> {{$t('modalWarning') }} </strong></p>
      
    </DialogPrime>
  </div>
</template>
<script>
import UserService from "@/services/UserService";
import { required, email, minLength, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { ToastSeverity } from "primevue/api";

export default {
  data() {
    return {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      sector: "",
      company: "",
      charge: "",
      reveal: false,
      signUp: true,
      changePwd: true,
      header: "Sign In",
      users: [],

      modalVisible: false,
      toNeobuq : false,
      toEcobuq: false,
    };
  },
  setup() {
    return { v$: useVuelidate(), v2$ : useVuelidate() };
  },
  validations() {
    return {
      email: { required, email },
      firstName: { required },
      lastName: { required },
      sector: { required },
      company: { required },
      charge: { required },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, minLength: minLength(6), sameAs: sameAs(this.password) }
    };
  },
  validations2(){
    return{
      newPassword: { required, minLength: minLength(6) },
      confirmNewPassword: { required, minLength: minLength(6), sameAs: sameAs(this.newPassword)}
    }
  },
  computed: {},
  created() {
    //console.log("Logging - created");
    this.userService = UserService.getInstance();
    this.userService.getUsers(this.users);
  },
  mounted() {},
  methods: {
    async setUser() {

      //console.log("Logging - setUser", this.signUp);
      if (this.header == "Sign Up") {
        const result = await this.v$.$validate();

        if (!result) {
          this.v$.$errors.forEach((error) => {
            const errorMessage = error.$property + ": " + error.$message;
            this.addErrorByToast(errorMessage);
          });
        } else {
          if (this.userService.emailVerification(this.email)) {
            this.userService.signIn(this.signUp, {
              email: this.email,
              password: this.password,
              firstName: this.firstName,
              lastName: this.lastName,
              sector: this.sector,
              company: this.company,
              charge: this.charge,
            });
          } else {
            this.addErrorByToast("ERROR. Ya existe usuario con ese email");
          }
        }
      } else {

        var section = ""
        if(this.toNeobuq && !this.toEcobuq){
          section = "NEOBUQ"
          //console.log("Logging Component: " + section)
          this.userService.signIn(this.signUp, { email: this.email, password: this.password }, section);

        }else if(!this.toNeobuq && this.toEcobuq){
          section = "ECOBUQ"
          //console.log("Logging Component: " + section)
          this.userService.signIn(this.signUp, { email: this.email, password: this.password }, section);

        }
      }
    },
    addErrorByToast(errorMsg) {
      this.$toast.add({
        severity: ToastSeverity.ERROR,
        closable: true,
        summary: errorMsg,
        life: 3000,
      });
    },
    createUser() {

      //volver a la pantalla de SignIn desde la de cambio de constraseña
      if(this.signUp && !this.changePwd){
        this.header = "Sign In";
        this.changePwd = true
      }else if (this.signUp && this.changePwd) {
        this.header = "Sign Up";
        this.signUp = false;
      } else {
        this.header = "Sign In";
        this.signUp = true;
      }

    },
    changePassword(){

      if(this.changePwd){
        this.header = "Change Password";
        this.changePwd = false
      }else {
        this.changePwd = true
      }

    },

    async setNewPassword(){

        var result = false
        //console.log(this.newPassword.length)

        //6 es el número mínimo de caracteres que debe tener la contraseña
        if(this.newPassword.length >= 6  && this.newPassword === this.confirmNewPassword && this.newPassword != this.password){
          result = true
        }
        
        //si hay errores, los datos están mal, etc.
        if(!result){
          const errorMessage = "ERROR: Cambio de contraseña no válido"
          this.addErrorByToast(errorMessage);

        }else{
          //usamos 'emailVerification' porque comprueba si el user está registrado, y por la naturaleza de la función, devuelve 
          //un error si no está, así que lo ponemos como false la condición
          if (!this.userService.emailVerification(this.email)) {
            //console.log("Todo OK")
            var state = this.userService.changeUserPassword(this.email, this.password, this.newPassword);

            //si state es true, cambiamos al formulario de Login
            if(state){
              //console.log("Cambiamos al logging vengaa")

              this.createUser()
              this.$toast.add({
                severity: ToastSeverity.SUCCESS,
                closable: true,
                summary: "¡Contraseña cambiada con éxito!",
                life: 3000,
              });

            }else{
              this.addErrorByToast("ERROR: Contraseña nueva incorrecta.")
            }

          } else {
            this.addErrorByToast("ERROR. No se pudo cambiar la contraseña");
          }
        }
    },

    async goToEcobuq(){

      this.toEcobuq = true;
      this.toNeobuq = false;

      this.setUser()

    },

    async goToNeobuq(){

      this.toEcobuq = false;
      this.toNeobuq = true;

      this.setUser()

    },
    
    openModal() {

      if(this.email != "" && this.password != ""){
        this.modalVisible = true;
      }

    },
    closeModal() {
      this.modalVisible = false;
    }
  },
};
</script>
<style>
.logo {
  width: 5%;
  height: 5%;
}
#inner {
  display: table;
  margin: 0 auto !important;
}
#outer {
  width: 100%;
}
.field {
  margin-bottom: 10px !important;
}
.button-login {
  background-color: #04AA6D;
  border-color: #04AA6D;
  padding-left: 20%;
  text-align: center;
}

.button-login:hover{
  background-color: #0c5037;
  border-color: #0c5037;
}

.button-container {
  display: flex;
  margin-right: 50%;
}
</style>
